import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const Izlet: IModel = {
  title: "Izlet",
  apiPath: "hps/izleti/{id}/images",
  httpUpdateVerb: "put",
  forms: {
    default: {
      fields: ["image"],
    }
  },
  listViews: {
    default: {
      fields: ["image"],
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Slika",
      source: "image",
      ttoken: "common.fotografija",
      type: "images",
      maxFiles: 1
    },
    coreFields.created_by,
    coreFields.created_on,
  ],
};

export default Izlet;
